"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferPalletActionSource = void 0;
var TransferPalletActionSource;
(function (TransferPalletActionSource) {
    TransferPalletActionSource["CASE_SCANNER"] = "CASE_SCANNER";
    TransferPalletActionSource["TRANSFERS_CREATE_PALLET"] = "TRANSFERS_CREATE_PALLET";
    TransferPalletActionSource["TRANSFERS_ADD_CASES_TO_PALLET"] = "TRANSFERS_ADD_CASES_TO_PALLET";
    TransferPalletActionSource["TRANSFERS_CLOSE_PALLET"] = "TRANSFERS_CLOSE_PALLET";
    TransferPalletActionSource["TRANSFERS_REOPEN_PALLET"] = "TRANSFERS_REOPEN_PALLET";
    TransferPalletActionSource["TRANSFERS_SHIP_PALLET"] = "TRANSFERS_SHIP_PALLET";
    TransferPalletActionSource["WAREHOUSE_ARRIVAL_SCANNER"] = "WAREHOUSE_ARRIVAL_SCANNER";
    TransferPalletActionSource["POSTMAN"] = "POSTMAN";
    TransferPalletActionSource["INBOUND_SERVICE"] = "INBOUND_SERVICE";
})(TransferPalletActionSource = exports.TransferPalletActionSource || (exports.TransferPalletActionSource = {}));
//# sourceMappingURL=TransferPalletActionSource.js.map